<template>
  <v-card elevation="1" outlined>
    <v-toolbar flat dense>
      <span>{{ titulo }}</span>
      <v-spacer></v-spacer>
      <v-btn v-if="isViewMessaje == false && isRecibidos === true" class="btn_asignar" fa
        @click="$emit('filtrar-mensajes-no-leidos')">
        <span> No leídos ({{ noLeidos }}) </span>
      </v-btn>
    </v-toolbar>
    <v-divider></v-divider>
    <v-card-text>
      <v-row class="py-0">
        <v-col class="text-right py-0" dense>

          <v-tooltip bottom color="#1b1b1b">
            <template v-slot:activator="{ on }">
              <v-btn v-if="isViewMessaje == false" class="btn_eliminar px-0" :disabled="mensajesSeleccionados.length == undefined ||
                mensajesSeleccionados.length == 0
                " v-on="on" fab x-small @click="deleteMessages()">
                <v-icon>fa-trash-alt</v-icon>
              </v-btn>
            </template>
            <span>{{ mensajesSeleccionados.length === mensajes.length ? 'Vaciar carpeta' : 'Eliminar' }}</span>
          </v-tooltip>


        </v-col>
      </v-row>

      <v-row>
        <!-- <v-col cols="12">
          {{ mensajes }}
        </v-col> -->
        <v-col cols="12">

          <ComundataTableComp v-if="isViewMessaje == false" :items="mensajes" :headers="headers"
            v-model="mensajesSeleccionados" whitSearch whitSelect placeholderTextsearch="Buscar mensaje"
            noResultsText="Sin mensajes disponibles">

            <template v-slot:descripcion_perfil="{ item }">
              <div @click="onSelectMensaje(item)" style="cursor: pointer;">
                <span>{{ item.descripcion_perfil }}</span>
              </div>
            </template>

            <template v-slot:asunto="{ item }">
              <div @click="onSelectMensaje(item)" style="cursor: pointer;" class="colMensaje">
                <span>{{ item.asunto }}</span>
              </div>
            </template>

            <template v-slot:fec_us_ing="{ item }">
              <div @click="onSelectMensaje(item)" style="cursor: pointer;" class="colMensaje">
                <!-- AQUÍ QUIEREN AL FECHA COMPLETA EN FORMATO DD/MM/AA -->
                <span>{{ fechaFormateada(item.fec_us_ing) }}</span>
              </div>
            </template>

            <template v-slot:leido="{ item }">
              <ButtonComp @click="onSelectMensaje(item)"
                :icon-but="item.leido ? 'fas fa-envelope-open-text' : 'fas fa-envelope'"
                :classColor="item.leido ? 'grey' : 'success'"
                :tooltipText="item.leido ? 'Mensaje leido' : 'Mensaje sin leer'" />
            </template>
          </ComundataTableComp>

          <!-- <v-data-table
            v-if="isViewMessaje == false"
            v-model="mensajesSeleccionados"
            :mobile-breakpoint="0"
            :headers="headers"
            :items="mensajes"
            :search="search"
            :sort-by="['fec_us_ing']"
            class="elevation-1 black--text"
            show-select
          >
 >

            <template v-slot:item.descripcion_perfil="{ item }">
              <div @click="onSelectMensaje(item)">
                <span>{{ item.descripcion_perfil }}</span>
              </div>
            </template>

            <template v-slot:item.asunto="{ item }">
              <div
                @click="onSelectMensaje(item)"
                class="colMensaje"
              >
                <span>{{ item.asunto }}</span>
              </div>
            </template>

            <template v-slot:item.fec_us_ing="{ item }">
              <div
                @click="onSelectMensaje(item)"
                class="colMensaje"
              >
                <span>{{ item.fec_us_ing | filtroFullFechaHora }}</span>
              </div>
            </template>
          </v-data-table> -->
          <div v-if="isViewMessaje == true">
            <mark>
              <h2 class="px-1 py-1">{{ viewMessaje.asunto }}</h2>
            </mark>
            <h3 class="px-1 py-1">De:</h3>
            <span class="pl-2">{{ viewMessaje.emisor }}</span>
            <template v-if="viewMessaje.destinatarios.length">
              <h3 class="px-1 py-1">Para:</h3>
              <!-- {{ viewMessaje.destinatarios }} -->
              <div class="pl-2" v-for=" (fila, i) in (viewMessaje.destinatarios)" :key="i">
                {{ fila }}
              </div>

            </template>


            <br>
            <v-card elevation="0" outlined>
              <v-card-text class="px-1 py-2" v-html="viewMessaje.cuerpo"></v-card-text>
              <br /><br />
              <v-divider> </v-divider>
              <v-card-actions v-if="viewMessaje.adjuntos.length > 0">
                <v-container class="grey lighten-5 pb-2">
                  <v-row>
                    <v-col cols="8">
                      <h4 class="pb-0">Adjuntos:</h4>
                    </v-col>
                    <v-col cols="3" v-for="adjunto in viewMessaje.adjuntos" :key="adjunto.id" align="center">
                      <v-card class="pa-1" outlined>
                        {{ adjunto.nombre_original }}
                        <v-btn class="mx-2 btn_otro" :href="rutaS3 + adjunto.uri" target="_blank" fab x-small>
                          <v-icon>fa-file-download</v-icon>
                        </v-btn>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-actions>
            </v-card>
          </div>
        </v-col>
      </v-row>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions v-if="isViewMessaje == true">
      <v-spacer></v-spacer>
      <v-btn class="btn_eliminar" dark @click="volver()">Volver</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { API_URL, BUCKET_ORIGIN_SPACE } from "../../../../helpers/axios";
import { mapMutations, mapActions } from "vuex";
import ComundataTableComp from "../../../../components/ComponentsEst/ComundataTablecomp.vue";
import ButtonComp from "../../../../components/ComponentsEst/TableButtonComp.vue";
import moment from 'moment';

export default {
  name: "Mensajes",
  components: {
    ComundataTableComp,
    ButtonComp,
  },
  props: {
    search: {
      type: String,
      default: "",
    },
    isRecibidos: {
      type: Boolean,
      default: false,
    },
    isEnviados: {
      type: Boolean,
      default: false,
    },
    isEliminados: {
      type: Boolean,
      default: false,
    },
    isBorradores: {
      type: Boolean,
      default: false,
    },
    titulo: {
      type: String,
      default: "",
    },
    mensajes: {
      type: Array,
      default: Array,
    },

    isViewMessaje: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    ruta_api: API_URL,
    viewMessaje: {
      asunto: "",
      cuerpo: "",
      destinatarios: [],
      emisor: "",
      adjuntos: [],
    },
    mensajesSeleccionados: [],
    headers: [],
  }),
  created() {
    if (this.isBorradores) {
      this.headers = [
        /*             {
                text: "Seleccionar",
                value: "id_mensaje",
                sortable: false,
                class: "black--text",
            }, */
        {
          text: "Asunto",
          value: "asunto",
          align: "center",
          sortable: false,
          class: "black--text",
        },
        {
          text: "Fecha - Hora",
          value: "fec_us_ing",
          sortable: false,
          align: "center",
          class: "black--text",
        },
      ];
    } else {
      this.headers = [

        {
          text: "Enviado por",
          value: "descripcion_perfil",
          sortable: false,
          class: "header_datatable",
        },
        {
          text: "Asunto",
          value: "asunto",
          align: "center",
          sortable: false,
          class: "header_datatable",
        },
        {
          text: "Fecha - Hora",
          value: "fec_us_ing",
          align: "center",
          sortable: false,
          class: "header_datatable",
        },
        {
          text: "Estado",
          value: "leido",
          align: "center",
          sortable: false,
          class: "header_datatable",
        },
      ];
    }
  },
  mounted() {
    // this.addClaseSecondary();
  },
  updated() {
    // this.addClaseSecondary();
  },
  methods: {
    ...mapActions("login", ["parametroComponente"]),
    ...mapMutations("mensajeSis", ["setEnviarMens"]),
    // addClaseSecondary() {
    //   let ths = document.querySelectorAll("th[role='columnheader']");
    //   ths.forEach((th) => th.classList.add("secondary"));
    // },
    onSelectMensaje(item) {


      if (this.isBorradores == true) {
        this.$emit("select-mensaje", item, true);
      } else {
        // this.isViewMessaje = true;
        this.viewMessaje.asunto = item.asunto;
        this.viewMessaje.cuerpo = item.cuerpo;
        this.viewMessaje.emisor = `${item.nombre_persona} ${item.ape1_persona} ${item.ape2_persona} (${item.descripcion_perfil})`;
        this.viewMessaje.adjuntos = item.adjuntos;

        if (item.destinatarios != undefined || item.destinatarios) {
          this.viewMessaje.destinatarios = this.listar_destinatarios(item.destinatarios)
        }

        this.$emit("select-mensaje", item, false);
        if (item.leido == false && this.isRecibidos)
          this.$emit("marcar-leido", item);
      }
    },
    volver() {
      this.$emit("volver");
    },

    deleteMessages() {
      // PARA QUE DESPUES DE ELIMINAR USANDO SELECCIONANDO MENSAJE EN LA TABLA NO SE ACTUALIZA EL ARRAY DE LOS SELECCIONADOS (DEBERIÁ ESTAR BASIO DESPUES DE BORRARSE)

      const copySeleccionados = [...this.mensajesSeleccionados]
      // USAMOS UNA COPIA PARA BORRAR LOS ELEMENTOS ENVIADOS PORQUE EL ORIGINAL SE VACIA ANTES DEL EVENTO
      this.$emit('delete-messages', copySeleccionados, this.isEnviados)
      // PARA VACIAR EL ARRAY Y NO HAYA CONFLICTO DESPUES
      this.mensajesSeleccionados.splice(0)

      // SE ENTIENDE QUE NO ES LO IDEA PERO SIRVE COMO COMO ALTERNATIVA AL PROBLEMA DE COMUNICACION ENTRE COMPONENTES
    },

    listar_destinatarios(destinatarios) {
      // Crear un objeto para almacenar los grupos de personas por perfil
      let grupos = {};
      // Iterar a través de cada destinatario
      destinatarios.forEach(({ usuario: { persona, perfil } }) => {
        let nombreCompleto = persona.nombre_persona + ' ' + persona.ape1_persona + ' ' + persona.ape2_persona;
        let descPerfil = perfil.descripcion_perfil;

        if (!grupos[descPerfil]) {
          grupos[descPerfil] = [];
        }

        // Agregar el nombre completo al grupo correspondiente
        grupos[descPerfil].push(nombreCompleto);
      });

      let fila = []

      for (let perfil in grupos) {
        fila.push(`${perfil}(s): ${grupos[perfil].join(', ')}.`)
      }
      return fila;
    },

    fechaFormateada(fecha_c) {
      const hora = moment(fecha_c).format('hh:mm A')
      const fecha = moment(fecha_c).format('DD/MM/YY')
      return `${fecha} ${hora}`
    },

  },
  computed: {

    noLeidos() {
      return this.mensajes.filter((d) => d.leido == false).length;
    },

    rutaS3() {
      return BUCKET_ORIGIN_SPACE + "/"
    }
  },
};
</script>

<style scope>
.fixed-first-column {
  position: sticky;
  left: 0;
  z-index: 1;
  background-color: #fff;
}

.colMensaje {
  cursor: pointer !important;
}

@media (max-width: 600px) {
  .data-table {
    min-width: 400px;
  }
}
</style>
